import { Button } from '@usealloy/component-library';
import styled, { keyframes } from 'styled-components';
import { ContainerType } from '../../../../types';

export const gentleBlinking = keyframes`
  0% {
    opacity: 0.6;
  }
  25% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
  75% {
    opacity: 1;
  }
  100% {
    opacity: 0.6;
  }
`;

export const StyledPendingOpenParenthesis = styled.div`
  color: var(--cl-gray-600);
`;

export const StyledPendingClosingParenthesisContainer = styled.div<{ containerType: ContainerType }>`
  display: flex;
  font-family: var(--cl-font-family-mono);
  font-size: var(--cl-font-size-2);
  align-self: ${({ containerType }) => (containerType === ContainerType.ISLAND ? 'flex-end' : 'center')};
`;

export const StyledPendingClosingParenthesisDropdown = styled.div<{ containerType: ContainerType }>`
  display: flex;
  flex-shrink: 0;
  font-weight: bold;
  background-color: var(--cl-yellow-300);
  border-radius: var(--cl-radius-1);
  color: var(--cl-text-default);
  font-weight: bold;
  animation: ${gentleBlinking} 1000ms ease infinite;
  left: -5px;
  right: 0;
  margin: 0 3px;
  align-self: ${({ containerType }) => (containerType === ContainerType.ISLAND ? 'flex-end' : 'center')};
`;

export const StyledHoverButton = styled(Button)`
  && {
    color: var(--cl-gray-500);
    font-weight: var(--cl-font-weight-medium);
    padding: 0;
    margin-left: var(--cl-space-2);
  }
`;
